import {IResult} from "./IResult";
import {AbstractSearchCore} from "./AbstractSearchCore";
import {AbstractSubscriber} from "./AbstractSubscriber";
import {IFacet} from "./IFacet";

export class SearchResultsSubscriber extends AbstractSubscriber {
  core: AbstractSearchCore | undefined;
  onResultUpdateCallback: (result: IResult) => void;
  onUpdateFacetsCallback: (quantity: number) => void;
  setQueryCallback: () => void;
  constructor(
    groupId: string,
    onResultUpdateCallback: (result: IResult) => void,
    updateFacetsCallback: (quantity: number) => void,
    setQueryCallback: () => void
  ) {
    super(groupId);
    this.onResultUpdateCallback = onResultUpdateCallback;
    this.onUpdateFacetsCallback = updateFacetsCallback;
    this.setQueryCallback = setQueryCallback;
  }
  public async attached(searchCore: AbstractSearchCore): Promise<void> {
    this.core = searchCore;
    this.setQueryCallback();
  }

  public setQuery(query: string) {
    this.core?.setQuery(query);
  }

  public async onResultUpdate(result: IResult): Promise<void> {
    this.onResultUpdateCallback(result);
  }

  public setPage(pageNumber: number) {
    this.core?.setPage(pageNumber)
  }

  detaching(): void {
  }

  onFacetUpdate(facets: IFacet[]): Promise<void> {
    console.log(facets);
    let facetsQuantity = 0;
    facets.forEach(facet => {
      facetsQuantity = facetsQuantity + facet.options?.filter(option => option.selected)?.length
    })
    this.onUpdateFacetsCallback(facetsQuantity);
    return Promise.resolve(undefined);
  }

  onSearchTextUpdate(text: string): Promise<void> {
    console.log(text);
    return Promise.resolve(undefined);
  }
}